import { useQuery } from "@tanstack/react-query";
import api from "../../../api";
import { createError, HTTPErrors } from "../../../errors";

type UseFetchCheckTokenProps = {
  token: string;
};

export const useFetchCheckToken = ({ token }: UseFetchCheckTokenProps) => {
  return useQuery<unknown, HTTPErrors>({
    queryKey: [`/api/v1/activations/${token}`],
    queryFn: async () => {
      const response = await api.get(`/api/v1/activations/${token}`);

      if (response.ok) {
        return null;
      }
      throw await createError(response);
    },
    retry: 0,
    refetchOnWindowFocus: false,
  });
};
